import './util/modernizr-custom';
import './custom/accordion';
import './custom/match-height';
import './plugins/slick.min';
import common from './routes/common';
import home from './routes/home';
import our_work from './routes/our_work';
// import thinking_brands from './routes/thinking_brands';
import careers from './routes/careers';
import single_our_work from './routes/single_our_work';
import blog from './routes/blog';
import charity from './routes/charity';

// Keep it last so my styles overrides modules
import '../styles/main.scss';

let windowWidth, windowHeight, documentWidth, documentHeight, topScrollPosition;
const siteRoot = window.location.protocol + '//' + window.location.host;

jQuery(document).ready(function ($) {
    const body = $('body');

    common.init();
    home.init();
    our_work.init();
    // thinking_brands.init();
    careers.init();
    single_our_work.init();
    // blog.init();
    charity.init();

    function recalculateSizes() {
        windowWidth = $(window).width(); //retrieve current window width
        windowHeight = $(window).height(); //retrieve current window height
        documentWidth = $(document).width(); //retrieve current document width
        documentHeight = $(document).height(); //retrieve current document height
        topScrollPosition = $(window).scrollTop(); //retrieve the document scroll ToP position
    }
    recalculateSizes();

    $('.accordion').nkAccordion();
    $('.post-list-wrap .portfolio-item').matchHeight();

    let mediaSlider = $('.media-slider');
    let slideNumberHolder = $('.slide-number span');
    mediaSlider.on('afterChange', function (event, slick, currentSlide) {
        // console.log(currentSlide);
        slideNumberHolder.text(currentSlide + 1);
    });
    mediaSlider.slick({
        dots: true,
        arrows: true,
        infinite: true,
        fade: false,
        cssEase: 'linear',
        speed: 300,
        autoplay: false,
        autoplaySpeed: 4000,
        prevArrow:
            '<div class="slick-prev slick-prev-square" aria-label="Previous" type="button"><svg id="slider-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><g><rect class="cls-1s" width="80" height="80"/><g><path class="cls-2s" d="m59.68,39.45H20.53"/><path class="cls-2s" d="m33.49,52.91l-13.49-13.41,13.49-13.5"/></g></g></svg></div>',
        nextArrow:
            '<div class="slick-next slick-next-square" aria-label="Next" type="button">Next<svg id="slider-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><g><rect class="cls-1s" width="80" height="80"/><g><path class="cls-2s" d="m59.68,39.45H20.53"/><path class="cls-2s" d="m46.19,26l13.49,13.41-13.49,13.5"/></g></g></svg></div>',
    });

    $('.testimonial-slider').slick({
        dots: true,
        arrows: true,
        infinite: true,
        fade: false,
        cssEase: 'linear',
        speed: 300,
        autoplay: false,
        autoplaySpeed: 4000,
        prevArrow:
            '<div class="slick-prev slick-prev-square" aria-label="Previous" type="button"><svg id="slider-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><g><rect class="cls-1s" width="80" height="80"/><g><path class="cls-2s" d="m59.68,39.45H20.53"/><path class="cls-2s" d="m33.49,52.91l-13.49-13.41,13.49-13.5"/></g></g></svg></div>',
        nextArrow:
            '<div class="slick-next slick-next-square" aria-label="Next" type="button">Next<svg id="slider-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"><g><rect class="cls-1s" width="80" height="80"/><g><path class="cls-2s" d="m59.68,39.45H20.53"/><path class="cls-2s" d="m46.19,26l13.49,13.41-13.49,13.5"/></g></g></svg></div>',
    });

    $('.text-size-72').closest('p').addClass('with-bigger-text');
    $('.text-size-60').closest('p').addClass('with-bigger-text');

    // $('.btn-contact-landing').on('click', function(e) {
    //     e.preventDefault();
    //     $('html,body').animate({
    //         scrollTop: $('#landing-contact').offset().top - 100
    //     }, 500);
    // });

    /*-------------------------------------------------------------------------*/
    //
    // INFO: File download on CF7 sent
    //
    /*-------------------------------------------------------------------------*/
    function downloadFile(link, file) {
        var hidden_a = document.createElement('a');
        hidden_a.setAttribute('href', link);
        hidden_a.setAttribute('class', 'form-download-link');
        hidden_a.setAttribute('download', file);
        document.body.appendChild(hidden_a);
        hidden_a.click();
    }
    $('.flexible-landing-file .wpcf7').on('wpcf7mailsent', function (e) {
        // console.log('link clicked');
        const wrapper = $(this).closest('.flexible-landing-file');
        const dataLink = wrapper.attr('data-link');
        const dataFile = wrapper.attr('data-file');
        downloadFile(dataLink, dataFile);
    });

    // execute on resize but only once
    let doResize;
    $(window).on('resize', function () {
        clearTimeout(doResize);
        doResize = setTimeout(function () {}, 300);
    });

    let doScroll;
    $(window).on('scroll', function () {
        clearTimeout(doScroll);
        doScroll = setTimeout(function () {}, 300);
    });

    $(window).on('orientationchange', function (event) {});
});

jQuery(window).on('load', function () {
    jQuery(window).trigger('resize');

    /*-------------------------------------------------------------------------*/
    //
    /* !	Hashed home section
    //
    /*-------------------------------------------------------------------------*/
    function homeSectionHash() {
        if (!$('body.home').length) return;
        var urlParams = new URLSearchParams(window.location.search); //get all parameters
        var hashValue = urlParams.get('show');
        console.log('hashValue', hashValue);
        if (hashValue) {
            $('html,body').animate(
                {
                    scrollTop: $('#' + hashValue).offset().top - 100,
                },
                500
            );
        }
    }
    homeSectionHash();
});
